import { useQuery } from '@tanstack/react-query';
import { getCacheTime } from '../query/time';
import { FetchBlobUrlOptions, fetchReferenceImageBlobUrl } from './api';

export const useReferenceImageUrl = (options: FetchBlobUrlOptions) =>
  useQuery({
    queryKey: ['chatbotReferenceImageUrl', options],
    queryFn: () => fetchReferenceImageBlobUrl(options),
    ...getCacheTime('infinite'),
  });
